  
 
 
<h2 mat-dialog-title>
  <span class="groupIcon"><mat-icon>backup_table</mat-icon></span>
  Import Question Template
  <button mat-icon-button (click)="closeImportQuestionTemplate()">
    <mat-icon>close</mat-icon>
  </button>
</h2>
    
  <!-- <mat-dialog-content> -->
   
    <div class="template-holder">
      <div class="left">
  
        <mat-form-field appearance="fill">
          <mat-label>Select Category</mat-label>
          <mat-select (selectionChange)="OnSelectCategoryImportTemp($event)" value="My Template">
            <mat-option value="My Template">My Template</mat-option>
            <mat-option value="Organization">Organization</mat-option>
            <mat-option value="Global">Global</mat-option>
          </mat-select>
        </mat-form-field>
  
        <div class="list" #categoryList>
          <ul>
            <li (click)="getThroughCategoryForQuestionTempImport(0, 0)" [ngClass]="{'active': currentIndex == 0 }">
              All
            </li>
            <ng-container *ngFor="let stat of filteredQuestionCategoryList; let i = index">
              <li (click)="getThroughCategoryForQuestionTempImport(stat.nlpTemplateCategoryID, i+1)"
                [ngClass]="{'active': currentIndex == i+1 }"> {{ stat.nlpTemplateCategoryName }}</li>
            </ng-container>
          </ul>
  
        </div>
  
      </div>
      <div class="right">
  
        <div class="list">
  
          <div class="tempalteList">
            <table cellspacing="0" cellspadding="0" width="100%">
              <tr>
                <th>Template Name</th>
                <th class="actBtn">Action</th>
              </tr>
              <tr *ngFor="let template of NLPTemplatesList"
                [ngClass]="{ 'active': template.templateID === QuestionTemplateIDImportTask}"
                [ngStyle]="{ 'background-color': template.templateID === QuestionTemplateIDImportTask ? '#e8f0fe' : 'transparent' }">
  
                <td class="formName">
                  {{template.tempalteName}}
                </td>
  
                <td>
                  <button mat-stroked-button color="primary"
                    (click)="SelectTemplateQuestionTempForImport(template)">Select</button>
                </td>
              </tr>
            </table>
            <div *ngIf="ShowNoRecordFoundQuestionTemplate" class="noRecordFound">No Record Found</div>
          </div>
  
        </div>
  
      </div>
    </div>
  
    <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-button color="basic" (click)="closeImportQuestionTemplate()">Cancel</button>
      <button mat-flat-button class="calltoaction" type="submit" color="primary" *ngIf="QuestionTemplateIDImportTask!=0"
        (click)="importQuestionTemplates()">
        Import
      </button>
    </mat-dialog-actions>

    
  
  <!-- </mat-dialog-content> -->
  
 

 
  

  

  




